var map = {
	"./news_list_0.jpg": "d88f",
	"./news_list_1.jpg": "e754",
	"./news_list_2.jpg": "5024",
	"./news_list_3.jpg": "9455",
	"./news_list_4.jpg": "0125",
	"./news_list_5.jpg": "3a84",
	"./news_list_6.jpg": "aca0",
	"./news_list_7.jpg": "7257"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aebd";